// import type { FleetEvent } from './types'

// const FILES = [
//   'trip_1_cross_country.json',
//   'trip_2_urban_dense.json',
//   'trip_3_mountain_cancelled.json',
//   'trip_4_southern_technical.json',
//   'trip_5_regional_logistics.json',
// ]

// const toMs = (iso: string) => Date.parse(iso)

// export async function loadData() {
//   const docs = await Promise.all(
//     FILES.map(async (file) => {
//       const r = await fetch(`/data/${file}`)
//       if (!r.ok) throw new Error(`Failed to load ${file}: ${r.status}`)
//       return r.json()
//     })
//   )

//   // each file may be {events: [...]} or just an array; handle both
//   const events: FleetEvent[] = docs.flatMap((doc: any) => {
//     const arr = Array.isArray(doc) ? doc : (doc.events ?? doc.data ?? doc)
//     return (arr as any[]).map(ev => {
//       const lat = ev.location?.lat
//       const lon = ev.location?.lng
//       const speedKph = ev.movement?.speed_kmh
//       const fuelPct = ev.telemetry?.fuel_level_percent ?? ev.fuel_level_percent ?? ev.fuel_level_after_refuel
//       const overspeed = ev.overspeed === true || ev.event_type === 'speed_violation'

//       return {
//         tripId: ev.trip_id,
//         ts: toMs(ev.timestamp),
//         type: ev.event_type,
//         lat: typeof lat === 'number' ? lat : undefined,
//         lon: typeof lon === 'number' ? lon : undefined,
//         speedKph,
//         fuelPct,
//         overspeed,
//         note: ev.error_message || ev.cancellation_reason,
//       } as FleetEvent
//     })
//   }).filter(e => Number.isFinite(e.ts) && e.tripId)

//   events.sort((a, b) => a.ts - b.ts)

//   const start = events[0]?.ts ?? 0
//   const end   = events.at(-1)?.ts ?? 0

//   // quick sanity log
//   const trips = new Set(events.map(e => e.tripId))
//   const withCoords = events.filter(e => Number.isFinite(e.lat) && Number.isFinite(e.lon)).length
//   console.log('[loadData]', { total: events.length, trips, withCoords, start: new Date(start), end: new Date(end) })

//   return { events, start, end }
// }
// src/data/loadData.ts
import type { FleetEvent } from './types'

const FILES = [
  'trip_1_cross_country.json',
  'trip_2_urban_dense.json',
  'trip_3_mountain_cancelled.json',
  'trip_4_southern_technical.json',
  'trip_5_regional_logistics.json',
]

const toMs = (iso: string) => Date.parse(iso)

export async function loadData() {
  const docs = await Promise.all(
    FILES.map(async (file) => {
      const r = await fetch(`/data/${file}`)
      if (!r.ok) throw new Error(`Failed to load ${file}: ${r.status}`)
      return r.json()
    })
  )

  // each file may be {events: [...]}, {data: [...]}, or [...] — handle all
  const events: FleetEvent[] = docs
    .flatMap((doc: any) => {
      const arr = Array.isArray(doc) ? doc : (doc.events ?? doc.data ?? doc)
      return (arr as any[]).map((ev): FleetEvent => {
        const loc = ev.location ?? {}
        const move = ev.movement ?? {}
        const dev  = ev.device ?? {}
        const tele = ev.telemetry ?? {}

        const lat = loc.lat
        const lon = loc.lng

        // speed / fuel / battery from multiple possible fields
        const speedKph = move.speed_kmh
        const fuelPct =
          tele.fuel_level_percent ??
          ev.fuel_level_percent ??
          ev.fuel_level_after_refuel
        const batteryPct =
          dev.battery_level ??
          ev.battery_level_percent

        // planned / total / travelled distance
        const distanceTotalKm =
          ev.planned_distance_km ??
          ev.total_distance_km
        const distanceTravelledKm = ev.distance_travelled_km

        // odometer if provided inside telemetry
        const odometerKm =
          tele.odometer_km ??
          ev.odometer_km

        // overspeed from flag or event type
        const overspeed = ev.overspeed === true || ev.event_type === 'speed_violation'

        // signal flags
        const signalLost = ev.event_type === 'signal_lost'
        const signalRecovered = ev.event_type === 'signal_recovered'

        return {
          tripId: ev.trip_id,
          ts: toMs(ev.timestamp),
          type: ev.event_type,

          lat: typeof lat === 'number' ? lat : undefined,
          lon: typeof lon === 'number' ? lon : undefined,

          vehicleId: ev.vehicle_id,
          speedKph: typeof speedKph === 'number' ? speedKph : undefined,
          fuelPct: typeof fuelPct === 'number' ? fuelPct : undefined,
          batteryPct: typeof batteryPct === 'number' ? batteryPct : undefined,

          distanceTotalKm: typeof distanceTotalKm === 'number' ? distanceTotalKm : undefined,
          distanceTravelledKm: typeof distanceTravelledKm === 'number' ? distanceTravelledKm : undefined,
          odometerKm: typeof odometerKm === 'number' ? odometerKm : undefined,

          overspeed,
          signalLost,
          signalRecovered,

          note: ev.error_message || ev.cancellation_reason,
        }
      })
    })
    .filter((e) => Number.isFinite(e.ts) && e.tripId)

  events.sort((a, b) => a.ts - b.ts)

  const start = events[0]?.ts ?? 0
  const end   = events.at(-1)?.ts ?? 0

  // quick sanity log
  const trips = new Set(events.map(e => e.tripId))
  const withCoords = events.filter(e => Number.isFinite(e.lat) && Number.isFinite(e.lon)).length
  console.log('[loadData]', { total: events.length, trips, withCoords, start: new Date(start), end: new Date(end) })

  return { events, start, end }
}
